import { z } from 'zod';
import type { JurionRole } from '@/shared/db/tenant';

export const INVALID_SESSION_CODE = 'invalid_session' as const;
export const SESSION_ACCESS_UPDATED_CODE = 'session_access_updated' as const;

export const roleSnapshotSchema = z.object({
  perfil: z.number(),
  administracao: z.boolean(),
  juridico: z.boolean(),
  comercial: z.boolean(),
  financeiro: z.boolean(),
  principal: z.boolean(),
  revisor: z.boolean(),
  controller: z.boolean(),
  marketing: z.boolean().default(false),
  credenciais: z.boolean().default(false),
  ativo: z.boolean(),
});

/**
 * Valida o snapshot persistido antes que ele atravesse a fronteira de autorização.
 * Apenas `marketing` e `credenciais` podem faltar para compatibilidade com sessões
 * legadas; qualquer outro desvio estrutural ou vínculo inativo falha fechado.
 */
export function parseRoleSnapshot(raw: unknown): JurionRole | null {
  let candidate = raw;
  if (typeof raw === 'string') {
    try {
      candidate = JSON.parse(raw);
    } catch {
      return null;
    }
  }

  const parsed = roleSnapshotSchema.safeParse(candidate);
  if (!parsed.success || !parsed.data.ativo) return null;
  return parsed.data;
}
